import React, { Component } from 'react';
import { css } from '@emotion/core';
import { Link } from 'react-router';
import ItemSlider from '../../../shared/ItemSlider/ItemSlider';
import ProductThumbnail from '../../../shared/ProductThumbnail/ProductThumbnail';

import './ProductsCarousel.scss';

class ProductsCarousel extends Component {
  renderProducts = (productsToShow, productsExplodedMobileView) => {
    const { isMobile } = this.props;
    if (!isMobile) {
      return this.renderProductsDesktop(productsToShow);
    } else if (productsExplodedMobileView) {
      return this.renderProductsMobile(productsToShow);
    } else {
      return this.renderAlternativeView(productsToShow);
    }
  };

  renderProductsDesktop = productsToShow => {
    return (
      <div className="hidden-mobile">
        <ItemSlider
          loading={this.props.loading}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          sliderCircleArrowsProducts={this.props.sliderCircleArrowsProducts}
          productsCarouselVersion={this.props.productsCarouselVersion}
        >
          {!!this.props[productsToShow] &&
            this.props[productsToShow].map(product => {
              return (
                <div className="mobile-thumbnail">
                  <ProductThumbnail
                    key={product.id}
                    product={product}
                    list="Latest/Bestsellers slider"
                    productsCarouselVersion={this.props.productsCarouselVersion}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                    coloredBackgroundProducts={
                      this.props.coloredBackgroundProducts
                    }
                  />
                </div>
              );
            })}
        </ItemSlider>
      </div>
    );
  };

  renderProductsMobile = productsToShow => {
    return (
      <div className="hidden-desktop">
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            // rowGap: '1rem',
          }}
        >
          {!!this.props[productsToShow] &&
            this.props[productsToShow].slice(0, 6).map((product, index) => {
              return (
                <div style={{ width: '48%' }} className="mobile-thumbnail">
                  <ProductThumbnail
                    key={product.id}
                    product={product}
                    list="Latest/Bestsellers slider"
                    productsCarouselVersion={this.props.productsCarouselVersion}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                    coloredBackgroundProducts={
                      this.props.coloredBackgroundProducts
                    }
                  />
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  renderAlternativeView = productsToShow => {
    return (
      <div className="alternative-view">
        <div
          style={{
            display: 'flex',
            overflowX: 'scroll',
            gap: 8,
            maxWidth: '100vw',
            paddingRight: 24,
          }}
        >
          {this.props[productsToShow].map(product => {
            return (
              <div className="mobile-thumbnail">
                <ProductThumbnail
                  key={product.id}
                  product={product}
                  list="Latest/Bestsellers slider"
                  productsCarouselVersion={this.props.productsCarouselVersion}
                  primaryColor={this.props.primaryColor}
                  secondaryColor={this.props.secondaryColor}
                  coloredBackgroundProducts={
                    this.props.coloredBackgroundProducts
                  }
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { selected, isMobile } = this.props;
    const productsToShow = selected;

    const containerVariants = css`
      &.version-1 {
        .latest-best-sellers {
          padding-left: 6%;
          @media screen and (max-width: 567px) {
            padding-left: 3%;
            padding-right: 3%;
          }
          ul .products-header {
            width: 94%;
            @media screen and (max-width: 567px) {
              flex-direction: column;
              gap: 5px;
            }
            .title {
              font-style: normal;
              font-weight: 400;
              font-size: 18px;
              line-height: 23px;
              @media screen and (max-width: 567px) {
                margin: 0px;
              }

              gap: 5px;
            }
            .title {
              font-style: normal;
              font-weight: 500;
              font-size: 22px;
              line-height: 29px;
              @media screen and (max-width: 567px) {
                margin: 0px;
              }
            }
          }
        }
      }
      &.colored-bg {
        background-color: #f8f8f8;
        border-radius: 6px;
        .latest-best-sellers {
          padding: 18px 49px 42px;
          @media screen and (max-width: 567px) {
            padding: 20px;
          }
        }
      }
      &.container-fluid.products {
        margin-right: 0px;
        margin-left: 3% !important;
      }
      &.container.products {
        display: block !important;
      }
    `;

    const showAllLink =
      selected === 'discounted' ? '/prodotti-in-offerta' : null;

    return (
      <div
        className={`version-${this.props.productsCarouselVersion} ${
          !isMobile
            ? this.props.productsCarouselVersion === 1
              ? 'container-fluid'
              : 'container'
            : this.props.productsCarouselVersion !== 2
            ? ''
            : 'container'
        }  ${this.props.coloredBackgroundProducts === 1 ? 'colored-bg' : ''}`}
        css={containerVariants}
      >
        <div className="latest-best-sellers">
          <div className="nav nav-pills">
            <div className="products-header">
              {this.props.productsCarouselTitle && (
                <h2 className="title">{this.props.productsCarouselTitle}</h2>
              )}
              {showAllLink && <Link to={showAllLink}>Vedi tutti</Link>}
            </div>
          </div>
          {this.renderProducts(
            productsToShow,
            this.props.productsExplodedMobileView
          )}
        </div>
      </div>
    );
  }
}
export default ProductsCarousel;
